export default "__VITE_ASSET__QIwrQQTX__"